var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.61426 27C7.78615 27 7.11426 26.5023 7.11426 25.8891V1.1109C7.11426 0.497654 7.78615 0 8.61426 0C9.44237 0 10.1143 0.497654 10.1143 1.1109V25.889C10.1143 26.5023 9.44237 27 8.61426 27Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.11656 26.9702C0.503779 26.9702 0.00659484 26.4729 0.00659484 25.8602V12.1833C-0.0596366 11.5738 0.380484 11.0259 0.990003 10.9597C1.59952 10.8935 2.14739 11.3336 2.21357 11.9431C2.222 12.023 2.222 12.1035 2.21357 12.1827V25.8596C2.21357 26.4678 1.72482 26.963 1.11656 26.9702Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.527 26.9729C14.9142 26.9729 14.417 26.4757 14.417 25.8629V6.64903C14.417 6.03625 14.9142 5.53906 15.527 5.53906C16.1397 5.53906 16.6369 6.0363 16.6369 6.64903V25.8629C16.6369 26.4757 16.1398 26.9729 15.527 26.9729Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6142 27C21.7861 27 21.1143 26.5195 21.1143 25.9274V18.0739C21.1134 17.4817 21.7844 17.0006 22.6125 17C23.4406 16.9994 24.1134 17.4792 24.1143 18.0714C24.1143 18.072 24.1143 18.0727 24.1143 18.0739V25.9274C24.1142 26.5195 23.4422 27 22.6142 27Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourse);
export default __webpack_public_path__ + "static/media/course.7273040c.svg";
export { ForwardRef as ReactComponent };